export const CARD_NUMBER_FORMAT = 'xxxx xxxxxx xxxxxx xxxxxxx';

// eslint-disable-next-line max-len
export const giftCardPinImgUrl = 'https://secure2.homedepot.com/hdus/en_US/DTCCOM/common/giftcard/Images/WhereDoIFindPIN-newCardV4-withoutTitle.jpg';

export const storeLocatorUrl = 'https://www.homedepot.com/l/store-locator';
export const MAX_BALANCE_AMT = 2000;
export const URL = {
  viewBalance: '/gift-cards/balance',
  plp: '/c/gift-cards'
};
export const VERBIAGE = {
  checkBalanceAndReload: 'Check Balance and Reload',
  reloadGiftCard: 'Reload Gift Card',
  checkAnotherBalance: 'Check Another Balance',
  backToGiftCards: 'Back to Gift Cards',
  reloadErrorMsg: `Gift cards can't exceed $${MAX_BALANCE_AMT}.`,
  maxBalanceReached: 'Maximum balance reached. Gift cards can\'t exceed $2000.',
  limitReached: 'You\'ve reached the 24 hour limit for purchasing gift cards.',
  technicalError: 'Sorry, we\'re experiencing technical difficulties. Please try again later.',
  selectAmount: 'Select Amount',
  continue: 'Continue',
  cancel: 'Cancel',
  enterAmount: 'Please enter an amount',
  invalidNumberDesktop: 'Invalid number. Please double-check your card details',
  invalidNumberMobile: 'or try scanning the barcode',
  pinTitle: 'Where is my PIN?',
  holdAmoutErr:
    'This card has funds on hold and can\'t be reloaded at this time. Please try again later.'
};

export const GIFTCARD_RELOAD_AMOUNTS = [100, 200, 300, 500];
export const MINIMUM_CUSTOM_AMOUNT = 1;
export const MINIMUM_CARD_AMOUNT = 5;
// programs that not allowed to check balance online
export const CHECK_BALANCE_RESTRICTED_PROGRAM = ['69', '79'];

export const addToCartPayload = {
  filterItem: true,
  localization: {
    primaryStoreId: 121
  },
  cartAttr: {
    essentialAccessories: true
  },
  items: {
    delivery: [
      {
        itemId: '999999999',
        storeSKU: '999741',
        quantity: '1',
        type: 'bopis',
        location: '0121',
        config: {
          type: 'GIFTCARD_RELOAD'
        }
      }
    ]
  }
};
export const NUCLEUS_CHECKOUT_PATH = '/checkout/giftcard-reload';
export const AUTH_PATH = '/auth/view/signin?redirect=/gift-cards/balance/ ';

export const containerWidthClass = 'sui-w-96';

export const FEATURE_SWITCH = {
  RELOAD_UI: 'ENABLE_GIFTCARD_RELOAD',
  RECAPTCHA: 'reCaptchaEnabled'
};
